import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import InputField from "../../InputField";
import exportImage from "../../../asset/Images";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import Alert from "../../../component/Alert";

export default function ExpensesAdd() {
  const [postAlert, setPostAlert] = useState();
  const [putAlert, setPutAlert] = useState();
  const navigate = useNavigate();
  const { handleSubmit, control, watch, setValue } = useForm({
    defaultValues: {
      formValue: [
        {
          item: "",
          description: "",
          qty: "",
          price: "",
          total: "",
        },
      ],
    },
  });
  const { fields, append, remove } = useFieldArray({
    name: "formValue",
    control,
  });
  const { formValue, paymentSplitting, descriptionCount } = watch();

  const descriptionOtherArray = Array.from(
    { length: descriptionCount },
    (_, i) => {
      return i + 1;
    }
  );
  const paymentSplittingArray = Array.from(
    { length: Number(paymentSplitting) },
    (_, i) => {
      return i + 1;
    }
  );

  const { mutate, isLoading } = useMutation(
    (postData) =>
      axios.post(`${process.env.REACT_APP_HOST}/newvisitors`, postData),
    {
      onSuccess: (data) => {
        navigate("/");
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );

  const onSubmit = (data) => {
    console.log("formData", data);
    setPostAlert(data);
  };

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">Quotation Add</div>
            <div className="header_branchSelect_container">
              <select className="branchSelect">
                <option value=""> -Select Branch- </option>
                <option value=""> 2k virtual World Branch </option>
                <option value=""> 2k virtual World Branch </option>
              </select>
            </div>
          </header>
          <section className="py-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form_OverAllContainer">
                <div className="commonForm_container">
                  <div className="input_container">
                    <label className="inputLabel">Vendor Name</label>
                    <Controller
                      control={control}
                      name="vendorName"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Purchase Date</label>
                    <Controller
                      control={control}
                      name="purchaseDate"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                          // placeholder="DD/MM/YYYY"
                        />
                        // <DateField {...field} commonInputCss="commonInputCss" />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">GST In</label>
                    <Controller
                      control={control}
                      name="gstIn"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">GST %</label>
                    <Controller
                      control={control}
                      name="gstPercentage"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Invoice No</label>
                    <Controller
                      control={control}
                      name="invoiceNo"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Site Name</label>
                    <Controller
                      control={control}
                      name="siteName"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Materials or Wages</label>
                    <Controller
                      control={control}
                      name="materialsWages"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                </div>

                {fields?.map((item, index) => {
                  const totalAmt =
                    formValue[index]?.qty * formValue[index]?.price;

                  return (
                    <div key={item.id} className="appendForm_container">
                      <div className="ItemInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Item</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.item`}
                          render={(field) => (
                            <InputField
                              {...field}
                              type="text"
                              commonInputCss="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="descriptionInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Description</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.description`}
                          render={(field) => (
                            <InputField
                              {...field}
                              type="text"
                              commonInputCss="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">QTY</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.qty`}
                          render={(field) => (
                            <InputField
                              {...field}
                              type="text"
                              commonInputCss="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Price</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.price`}
                          render={(field) => (
                            <InputField
                              {...field}
                              type="text"
                              commonInputCss="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Total</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.total`}
                          render={({
                            field: { onChange, onBlur, value, ref },
                          }) => (
                            <input
                              onChange={onChange}
                              value={totalAmt ? totalAmt : ""}
                              className="commonInputCss"
                            />

                            // <InputField
                            //   {...field}
                            //   type="text"
                            //   commonInputCss="commonInputCss"
                            // />
                          )}
                        />
                      </div>
                      <div className="appendBtnContainer">
                        <div
                          className="appendBtn"
                          onClick={() => {
                            append();
                          }}
                        >
                          <img
                            className="mb-1"
                            src={exportImage?.addIcon}
                            alt="addIcon"
                          />
                        </div>
                        {index !== 0 && (
                          <div
                            className="appendBtn"
                            onClick={() => {
                              remove(index);
                            }}
                          >
                            <img
                              className="mb-1"
                              src={exportImage?.deleteIcon}
                              alt="deleteIcon"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className="bankDetails_container">
                  <header className="header_title">Branch Details</header>
                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">
                        Current Acc Holder Name
                      </label>
                      <Controller
                        control={control}
                        name="currentAccHolderName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Bank Name</label>
                      <Controller
                        control={control}
                        name="bankName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">A/C No</label>
                      <Controller
                        control={control}
                        name="acNo"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">IFSC Code</label>
                      <Controller
                        control={control}
                        name="ifscCode"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Branch</label>
                      <Controller
                        control={control}
                        name="Branch"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Phone number</label>
                      <Controller
                        control={control}
                        name="bankPhoneNumber"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Payment Mode</label>
                      <Controller
                        control={control}
                        name="paymentMode"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Total</label>
                      <Controller
                        control={control}
                        name="total"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Payment Status</label>
                      <Controller
                        control={control}
                        name="paymentStatus"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Narration</label>
                      <Controller
                        control={control}
                        name="narration"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="submitBtnContainer">
                <button className="submitBtn" type="submit">
                  Get Expenses
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
      <Alert
        open={postAlert}
        setPutAlert={setPutAlert}
        postAlert={postAlert}
        // state={state}
        // upData={upData}
        putAlert={putAlert}
        mutate={mutate}
        navigates="/"
        // id={state?.id}
        add={true}
        onCloses={setPostAlert}
        // setPutAlert={setPutAlert}
      />
    </>
  );
}
